import React from 'react'
import Carrusel from '../components/Carrusel'
import '../css/ElReto.css' // Recuerda crear este CSS para el estilo del texto
import ChallengeMap from '../components/ChallengeMap'
import RecaudacionHistorica from '../components/RecaudacionHistorica'
import Colaboradores from './Colaboradores'

function ElReto() {
  return (
    <div className="reto-container">
      <header className="reto-header">
        <h1>El Reto de Carmen</h1>
        <div className="protagonista-section">
          <img 
            src="https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/imagenes%20presentaci%C3%B3n%2FCorreoso%20bicicleta.png?alt=media&token=ee960f87-f108-45ca-9c9e-09cb66260f04" 
            alt="Francisco Correoso" 
            width="214" 
            height="290" 
            className="foto-francisco"
          />
          <div className="texto-principal">
         <p>
  El <strong>Reto de Carmen</strong> es una declaración de superación encabezada por <strong>Francisco Correoso</strong>. 
  Este desafío consiste en unir <strong>Disneyland Paris con Higueruela</strong> en un trayecto de 
  <strong>1.444 km non-stop</strong>. Tras cruzar el corazón de Francia por <strong>Orleans</strong> y los viñedos de 
  <strong>Bordeaux</strong>, la ruta alcanzará su frontera natural en <strong>Saint-Jean-Pied-de-Port</strong>.
</p>

<p>
  La entrada en España será épica, coronando el <strong>Puerto de Ibañeta</strong> hacia <strong>Roncesvalles</strong> para 
  iniciar un descenso exigente por el verdor navarro de <strong>Aoiz</strong> y <strong>Sangüesa</strong>. Desde allí, el 
  camino se endurecerá atravesando las tierras de <strong>Teruel</strong> para entrar finalmente en Castilla-La Mancha a 
  través de <strong>Talayuelas</strong>.
</p>

<p>
  Al alcanzar las <strong>Hoces del Cabriel</strong>, el paisaje cambiará de nuevo. Un momento de profunda carga emocional 
  será el paso por <strong>Jorquera</strong> para cruzar el <strong> Júcar</strong>; en ese instante, al sentir el cauce del 
  río, Francisco se sentirá por fin como en casa. 
</p>

<p>
  La épica de este viaje alcanzará su punto álgido en los kilómetros finales. Tras dejar atrás <strong>Villamalea</strong>, 
  <strong>Casas de Juan Núñez</strong> y <strong>Pozo Lorente</strong>, Francisco se enfrentará al <strong>Puerto de Monfón</strong>, 
  la última gran dificultad montañosa que lo separa de su hogar y de culminar esta <strong>constelación de sonrisas</strong>.
</p>
          </div>
        </div>
      </header>

      <section className="agradecimientos">
        <p>
          Esta hazaña sería imposible sin su motor fundamental: su familia. Un agradecimiento infinito a <strong>Rosana</strong>, su mujer, y a su hijo <strong>Fran</strong>, pilares de este proyecto, así como al equipo de apoyo que lo escoltará durante cada kilómetro de este trayecto ininterrumpido. Juntos, convierten los 1450 km en un camino de esperanza.
        </p>
      </section>
      <RecaudacionHistorica/>

      <div className="carrusel-section">
        <Carrusel />
      </div>
      <div>
        <ChallengeMap/>
      </div>
     <div style={{ 
        width: '100%', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        marginTop: '60px', // Espacio respecto al mapa
        textAlign: 'center'
      }}>
  
      </div>
    </div>
  )
}

export default ElReto